module.exports = __webpack_public_path__ + "img/id-jt.9be0fcaa.svg";